/**
 * User模块接口列表
 */
import { base, userApiUrl } from './base' // 导入接口域名列表
import axios from '../utils/http' // 导入http中创建的axios实例
const debug = process.env.NODE_ENV !== 'production'
const baseURL = debug ? base.development : base.production
axios.defaults.baseURL = baseURL

const user = {
  register (params) {
    return axios.post(userApiUrl.REGISTER_URL, params)
  },
  login (params) {
    return axios.post(userApiUrl.LOGIN_URL, params)
  },
  logout () {
    return axios.get(userApiUrl.LOGOUT_URL)
  },
  findpwdByPhone (params) {
    return axios.post(userApiUrl.FINDPWD_BYPHONE_URL, params)
  },  
  findpwdByOrder (params) {
    return axios.post(userApiUrl.FINDPWD_BYORDER_URL, params)
  },
  findpwdVerify (params) {
    return axios.post(userApiUrl.FINDPWD_VERIFY_URL, params)
  },
  findpwdReset (params) {
    return axios.post(userApiUrl.FINDPWD_RESET_URL, params)
  },
  getQQLoginUrl () {
    return baseURL + userApiUrl.QQ_LOGIN_URL
  },
  getWeixinLoginUrl () {
    return baseURL + userApiUrl.WEIXIN_LOGIN_URL
  },
  getWeiboLoginUrl () {
    return baseURL + userApiUrl.WEIBO_LOGIN_URL
  },
  getUserInfo () {
    return axios.get(userApiUrl.GET_USER_INFO_URL)
  },
  bindmobile (params) {
    return axios.post(userApiUrl.BINDMOBILE_URL, params)
  },
  bindmail (params) {
    return axios.post(userApiUrl.BINDMAIL_URL, params)
  },
  verify (params) {
    return axios.post(userApiUrl.VERIFY_URL, params)
  },
  unbindmail (params) {
    return axios.post(userApiUrl.UNBINDMAIL_URL, params)
  },
  resendmail () {
    return axios.get(userApiUrl.RESEND_MAIL_URL)
  },
  secondVerify (params) {
    return axios.post(userApiUrl.SECONDVERIFY_URL, params)
  },
  changepassword (params) {
    return axios.post(userApiUrl.CHANGE_PASSWORD_URL, params)
  },
  getloginrecord (params) {
    return axios.get(userApiUrl.GET_LOGIN_RECORD_URL, { params: params })
  },
  uploadavatar (params) {
    return axios.post(userApiUrl.UPLOADAVATAR_URL, params, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  getorders (params) {
    return axios.get(userApiUrl.GET_ORDERS_URL, { params: params })
  },
  getcards (params) {
    return axios.get(userApiUrl.GET_CARDS_URL, { params: params })
  },
  gethistory (params) {
    return axios.get(userApiUrl.GET_HISTORY_URL, { params: params })
  },
  getfavlist (params) {
    return axios.get(userApiUrl.GET_FAVLIST_URL, { params: params })
  }
}

export default user
